import React from 'react';
import { Route } from '../types';
import RouteCard from './RouteCard';
import NavigationIcons from './NavigationIcons';
import { findParkingCoordinates } from '../utils/navigationUtils';
import { CragData } from '../utils/navigationUtils';

interface RouteGroupProps {
  group: {
    area: string;
    crag: string;
    displayName: string;
    routes: Route[];
  };
  userLocation?: { latitude: number; longitude: number };
  isRouteInBelayList: (route: Route) => boolean;
  onToggleBelayList: (route: Route) => void;
  showPitches?: boolean;
  onViewOnMap?: (route: Route) => void;
  cragsData?: CragData[];
}

export default function RouteGroup({
  group,
  userLocation,
  isRouteInBelayList,
  onToggleBelayList,
  showPitches = false,
  onViewOnMap,
  cragsData = [],
}: RouteGroupProps) {
  // Find parking coordinates for this crag/region
  const parkingCoordinates = findParkingCoordinates(group.crag, group.area, cragsData);

  return (
    <div className="mb-8">
      {/* Group Header */}
      <div className="mb-4">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-xl font-semibold text-gray-800 mb-1">
              {group.displayName}
            </h3>
            <p className="text-sm text-gray-600">
              {group.routes.length} route{group.routes.length !== 1 ? 's' : ''}
            </p>
          </div>
          {parkingCoordinates && (
            <NavigationIcons coordinates={parkingCoordinates} />
          )}
        </div>
      </div>

      {/* Route Cards */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {group.routes.map((route) => (
          <div key={route.Route || 'unknown'} id={`route-${String(route.Route || '').replace(/\s+/g, '-')}`}>
            <RouteCard
              route={route}
              distance={userLocation ? 
                Math.sqrt(
                  Math.pow(route['Area Latitude'] - userLocation.latitude, 2) +
                  Math.pow(route['Area Longitude'] - userLocation.longitude, 2)
                ) * 69 // Rough conversion to miles
                : undefined
              }
              isInBelayList={isRouteInBelayList(route)}
              onToggleBelayList={onToggleBelayList}
              userLocation={userLocation}
              showPitches={showPitches}
              onViewOnMap={onViewOnMap}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
